import { Chip } from "@mui/material";
import { useRecordContext } from "react-admin";

// The review flag is deliberately separate from the payment status: a paid bill whose hotel report
// is uncertain still reads as "Платена" and must never be presented as awaiting payment.
const ReviewFlagField = () => {
  const record = useRecordContext();

  if (!record?.requiresReview) {
    return null;
  }

  return (
    <Chip
      label="За проверка"
      color="warning"
      size="small"
    />
  );
};

export default ReviewFlagField;
